import { z } from "zod";

const zConstraint = z.enum(["UNIQUE_USER_EMAIL"]);
const Constraint = zConstraint.Values;
type Constraint = z.infer<typeof zConstraint>;

export { Constraint, zConstraint };
